export default {
  CREATE_KUSPIT_WITHDRAWAL_COMMAND: Symbol.for('CREATE_KUSPIT_WITHDRAWAL_COMMAND'),
  CREATE_KUSPIT_WITHDRAWAL_REPOSITORY: Symbol.for('CREATE_KUSPIT_WITHDRAWAL_REPOSITORY'),
  GET_CUSTOMER_WITHDRAWAL_DETAILS_QUERY: Symbol.for('GET_CUSTOMER_WITHDRAWAL_DETAILS_QUERY'),
  CUSTOMER_WITHDRAWAL_DETAILS_REPOSITORY: Symbol.for('CUSTOMER_WITHDRAWAL_DETAILS_REPOSITORY'),
  CUSTOMER_WITHDRAWAL_DETAILS_STATE_MANAGER: Symbol.for('CUSTOMER_WITHDRAWAL_DETAILS_STATE_MANAGER'),
};
